import { useContext } from "react";
import { StateContext, IStateContext } from "../context";

const useGlobalState = () => useContext(StateContext) as IStateContext;

export { useGlobalState };
